<template>

    <v-dialog v-model="show" persistent max-width="400" :attach="$store.state.fullscreenElement">
      <v-card>
        <v-card-title>
          <v-icon class="mr-4" color="#FB8C00">mdi-phone-ring-outline</v-icon>
          Paging Notification
        </v-card-title>

        <v-card-text>
            <div>
                <span style="fontWeight: bold; color: #FB8C00">TIME: </span>
                <span style="fontStyle: italic" v-text="$store.state.pagingClientMessage.time"></span>
            </div>
            <div>
                <span style="fontWeight: bold; color: #FB8C00">MESSAGE: </span>
                <span style="color: #ffffff" v-text="$store.state.pagingClientMessage.message"></span>
            </div>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <div class="flex-grow-1"></div>
          <v-btn text @click="$store.commit('closePagingClientDialog')">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

</template>

<script>
export default {
  name: 'PagingClientDialog',
  props: {
    value: Boolean,
  },
  data: () => ({
  }),

  computed: {
    show: {
        get () {
            return this.value
        },
        set (value) {
            this.$emit('input', value);
        }
    },
  },

  methods: {
  },

  mounted() {
  }

  
};
</script>

<style scoped>
</style>

